import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { Grid, FormLabel } from '@material-ui/core';
import { useState } from 'react';

const ATOptions = (props) => {
    const { handleTaxonomySelect } = props;
    let taxonomyData = props.TaxonomyData;

    return (
        <>
            {
                taxonomyData.vehicleTypes.length > 0 ?
                    <Grid item className='filterTopPage'>
                        <FormLabel className='labelInput'>
                            Vehicle Type
                        </FormLabel>
                        <Select
                            className='customSelectFilterSingle'
                            onChange={handleTaxonomySelect}
                            value={taxonomyData.vehicleType}
                            id="vehicleType"
                            name="vehicleType"
                        >
                            <MenuItem value={"none"}>None</MenuItem>
                            {
                                taxonomyData.vehicleTypes.map((vehicleType) => {
                                    return <MenuItem value={vehicleType.name} key={vehicleType.name}>{vehicleType.name}</MenuItem>
                                })
                            }
                        </Select>
                    </Grid>
                    : null
            }
            {    
                taxonomyData.makes.length > 0 ? 
                    <Grid item className='filterTopPage'>
                        <FormLabel className='labelInput'>
                            Makes
                        </FormLabel>
                        <Select
                            className='customSelectFilterSingle'
                            onChange={handleTaxonomySelect}
                            value={taxonomyData.makeId}
                            id="make"
                            name="make"
                        >
                            <MenuItem value={"none"}>None</MenuItem>
                            {
                                taxonomyData.makes.map((make) => {
                                    return <MenuItem value={make.makeId} key={make.makeId}>{make.name}</MenuItem>
                                })
                            }
                        </Select>
                    </Grid>
                : null
            }
            {    
                taxonomyData.models !== null && taxonomyData.models.length > 0 ? 
                    <Grid item className='filterTopPage'>
                        <FormLabel className='labelInput'>
                            Models
                        </FormLabel>
                        <Select
                            className='customSelectFilterSingle'
                            onChange={handleTaxonomySelect}
                            value={taxonomyData.modelId}
                            id="model"
                            name="model"
                        >
                            <MenuItem value={"none"}>None</MenuItem>
                            {
                                taxonomyData.models.map((model) => {
                                    return <MenuItem value={model.modelId} key={model.modelId}>{model.name}</MenuItem>
                                })
                            }
                        </Select>
                    </Grid>
                : null
            }
            {    
                taxonomyData.generations !== null && taxonomyData.generations.length > 0 ? 
                    <Grid item className='filterTopPage'>
                        <FormLabel className='labelInput'>
                            Generations
                        </FormLabel>
                        <Select
                            className='customSelectFilterSingle'
                            onChange={handleTaxonomySelect}
                            value={taxonomyData.generationId}
                            id="generation"
                            name="generation"
                        >
                            <MenuItem value={"none"}>None</MenuItem>
                            {
                                taxonomyData.generations.map((generation) => {
                                    return <MenuItem value={generation.generationId} key={generation.generationId}>{generation.name}</MenuItem>
                                })
                            }
                        </Select>
                    </Grid>
                : null
            }
            {    
                taxonomyData.derivatives !== null && taxonomyData.derivatives.length > 0 ? 
                    <Grid item className='filterTopPage'>
                        <FormLabel className='labelInput'>
                            Derivatives
                        </FormLabel>
                        <Select
                            className='customSelectFilterSingle'
                            onChange={handleTaxonomySelect}
                            value={taxonomyData.derivativeId}
                            id="derivative"
                            name="derivative"
                        >
                            <MenuItem value={"none"}>None</MenuItem>
                            {
                                taxonomyData.derivatives.map((derivative) => {
                                    return <MenuItem value={derivative.derivativeId} key={derivative.derivativeId}>{derivative.name}</MenuItem>
                                })
                            }
                        </Select>
                    </Grid>
                : null
            }
        </>

    );
}

export default ATOptions;